import { Field } from 'react-final-form';
import { Box, Flex } from 'components/box';
import RadioButton from 'components/form/radio-button';
import { ReactNode } from 'react';
import FormError from 'components/form/error';

export const YesNoRadio = ({
  children,
  name,
}: {
  children: ReactNode;
  name: string;
}) => (
  <Box>
    {children}

    <Flex mt={2} ml={-2}>
      <Field<string>
        value="Yes"
        name={name}
        type="radio"
        validate={value => (!value ? 'Please select an option' : null)}
      >
        {({ input, meta }) => (
          <Box>
            <RadioButton {...input} label="Yes" />
            {meta.error && meta.touched && (
              <FormError ml={2}>{meta.error}</FormError>
            )}
          </Box>
        )}
      </Field>

      <Field value="No" name={name} type="radio">
        {({ input }) => <RadioButton {...input} label="No" />}
      </Field>
    </Flex>
  </Box>
);
